import * as angular from "angular";

angular
.module('bringoz.admin.oms')
.component('omsAutomaticShipmentRulesTableRow', {
  bindings: {
    rule: '<',
    onEdit: '&',
    onDelete: '&'
  },
  template: require('./oms-automatic-shipment-rules-table-row.html').default
});
